var _defs, _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 16.5,
    x2: 21.5,
    y1: 19.67,
    y2: 28.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 22.56,
    x2: 39.2,
    y1: 21.96,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.53,
    x2: 25.47,
    y1: 42.95,
    y2: 48.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4286ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#4286ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0950bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 29.53,
    x2: 32.47,
    y1: 42.95,
    y2: 48.05,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 36.53,
    x2: 39.47,
    y1: 42.95,
    y2: 48.05,
    xlinkHref: "#a"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 24,
    r: 5,
    fill: "url(#b)",
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19 15.67V12.5m0 23v-3.17m5.89-14.22l2.24-2.24M10.87 32.13l2.24-2.24m0-11.78l-2.24-2.24m16.26 16.26l-2.24-2.24M7.5 24h3.17m19.83 0h-3.17"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "45s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 19 24; 360 19 24"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M46.5 31.5h-.32a10.49 10.49 0 00-19.11-8 7 7 0 00-10.57 6 7.21 7.21 0 00.1 1.14A7.5 7.5 0 0018 45.5a4.19 4.19 0 00.5 0v0h28a7 7 0 000-14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#a)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M24.39 43.03l-.78 4.94"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "0.7s",
    repeatCount: "indefinite",
    type: "translate",
    values: "1 -5; -2 10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "0.7s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#d)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M31.39 43.03l-.78 4.94"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.4s",
    dur: "0.7s",
    repeatCount: "indefinite",
    type: "translate",
    values: "1 -5; -2 10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.4s",
    dur: "0.7s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#e)",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M38.39 43.03l-.78 4.94"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.2s",
    dur: "0.7s",
    repeatCount: "indefinite",
    type: "translate",
    values: "1 -5; -2 10"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.2s",
    dur: "0.7s",
    repeatCount: "indefinite",
    values: "0;1;1;0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainDay);
export default __webpack_public_path__ + "static/media/rain-day.4c0668cce0f70c7678d55a2b1e7227f7.svg";
export { ForwardRef as ReactComponent };